<template lang="html">
  <div class="scrollable-content container-fluid">
    <div class=".scrollable-content-container">
      <div class="row no-gutters w-100">
        <div class="scrollable-content-content w-100">
          <slot></slot>
          <div class="bottom-spacer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scrollable-content'
};
</script>

<style lang="scss" scoped>
$spacing: $app-bar-height + $action-bar-height;
$spacing-mobile: $app-bar-height-mobile + $action-bar-height-mobile;

.scrollable-content {
  position: relative;

  .scrollable-content-container {
    padding-left: 15px;
    padding-right: 15px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
}

.scrollable-content-content {
  height: calc(100vh - #{$spacing});
  overflow: scroll;

  @media screen and (max-width: $breakpoint-sm) {
    height: calc(100vh - #{$spacing-mobile});
  }
}

.bottom-spacer {
  width: 100%;
  height: 80px;

  // @media screen and (max-width: $breakpoint-xl) {
  //   height: 180px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollableContent.vue